export default __webpack_public_path__ + "static/media/foundationBooklets.1db6785c.png";